import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'myabvv-search-button',
  templateUrl: './search-button.component.html',
  styleUrls: ['./search-button.component.css'],
  standalone: true,
  imports: [TranslatePipe],
})
export class SearchButtonComponent {
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' = 'button';
  @Output() searchClick = new EventEmitter<void>();
}
